<script setup>
  import ReportsComponent from "@/Components/Reports/ReportsComponent.vue";
  import {Permissions} from "@/Utils/Permissions";
</script>

<template>
  <v-container fluid>
    <v-row v-if="Permissions.checkPermissions(['dashboards.reports'])">
      <v-col cols="12">
        <ReportsComponent/>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>

</style>